import Vue from 'vue';
import { Amplify, API, Auth } from 'aws-amplify';
import '@aws-amplify/ui-vue';
import App from './App.vue';
import Loading from './components/Loading';
import { alert, confirm } from './dialog';
import router from './router';
import store from './store';
import awsExports from './aws-exports';

Vue.use(Loading);
Vue.prototype.$alert = alert;
Vue.prototype.$confirm = confirm;

Amplify.configure(awsExports);
API.configure(awsExports);
Auth.configure(awsExports);

Vue.config.productionTip = false;

Vue.filter('ymd', function(value) {
  if (!value) return '';
  let date = new Date(value);

  return date.getFullYear() + '/' + `${ date.getMonth() + 1 }`.padStart(2, '0') + '/' + `${date.getDate()}`.padStart(2, '0') + '';
});

Vue.filter('yen', function(value) {
  if (!value) return value;

  var number_data = String(parseFloat(value)).split('.');
  value = number_data[0];
  var result = '',
    counter = 0;
  value = (value || 0).toString();

  for (var i = value.length - 1; i >= 0; i--) {
    counter++;
    result = value.charAt(i) + result;
    if (!(counter % 3) && i != 0) {
      result = ',' + result;
    }
  }

  return result;
});
// window.$ = window.jQuery = require('jquery');
// window.datepicker = require('@chenfengyuan/datepicker');


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
